OE.addPlugin('Comments', (function(){

    var Plugin = {},
        Options = {
        },
        querySelector = '#respond';


    Plugin.init = function()
    {
        // alterStyle();
        addCommentLinks();
        addPermalinkLinks();

        openCommentsPopup();
        openCommentsCollapsable();
    };


    var openCommentsPopup = function()
    {
        var _jQuery = typeof $ !== 'undefined' ? $ : (typeof jQuery !== 'undefined' ? jQuery : null);

        if( _jQuery )
        {
            if(typeof _jQuery.magnificPopup !== 'undefined' )
            {
                if(OE.$win.location.hash && OE.$win.location.hash === querySelector)
                {
                    var respondLink = OE.$doc.querySelector('a[href*="' + querySelector + '"]');

                    if(respondLink)
                    {
                        _jQuery(respondLink).magnificPopup('open');
                    }
                }
            }
        }
    };

    var openCommentsCollapsable = function()
    {
        if(typeof OE.Plugins.Collapsable !== 'undefined')
        {
            var Respond = getRespondContainer();

            if(OE.$win.location.hash && OE.$win.location.hash === querySelector)
            {
                OE.Plugins.Collapsable.expand(Respond);
            }
        }
    };

    var alterStyle = function()
    {
        var Respond = getRespondContainer();

        if(Respond)
        {
            var replyTo = Respond.querySelector('.comments-reply-title > a');
            if(replyTo)
            {
                replyTo.outerHTML = '<span class="reply-to-name hilite">' + replyto.textContent + '</span>';
            }

            var ReplyTitle = Respond.querySelector('.comment-reply-title>small');
            if(ReplyTitle)
            {
                ReplyTitle.parentNode.removeChild(ReplyTitle);
            }

            var sbm = Respond.querySelector('input[type=submit]');
            if(sbm)
            {
                sbm.outerHTML = '<button type="submit" name="' + sbm.getAttribute('name') + '" id="' + sbm.getAttribute('id') + '">' + sbm.value + '</button>';
			}
        }
    };

    var addCommentLinks = function()
    {
        var Respond = getRespondContainer();

        if(Respond)
        {
            var commentLinks = OE.$doc.querySelectorAll('a[href*="' + querySelector + '"], a[href*="replytocom="]'),
                commentLink_count = commentLinks.length;

            for(var i = 0; i  < commentLink_count; i++)
            {
                var commentLink = commentLinks[i],
                    replytocom = OE.Utils.getURLParameter('replytocom', commentLink.getAttribute('href') );

                commentLink.setAttribute('href', querySelector);

                commentLink.addEventListener(CLICK, alterRespondForm.bind(commentLink, Respond, replytocom));
    		}
        }
    };

    var alterRespondForm = function(Respond, replytocom, e)
    {
        try { e.preventDefault(); } catch(ev) {}

        if(replytocom)
        {
            Respond.querySelector('input[name=comment_parent]').value = replytocom;
        }

        Respond.querySelector('.comment-reply-title').textContent = this.getAttribute('aria-label') || this.textContent;
    };

    var addPermalinkLinks = function()
    {
        var permalinks = OE.$doc.querySelectorAll('.comment .meta a[href*="#comment-"]'),
            permalink_count = permalinks.length;

        for( var i = 0; i < permalink_count; i++ )
        {
            var permalink = permalinks[i];

            permalink.addEventListener(CLICK, changeHistory);
        }
    };

    var changeHistory = function(e)
    {
        var stateObj = {
            url : this.getAttribute('href')
        };

        history.replaceState(stateObj, "", this.getAttribute('href') );

        try { e.preventDefault(); } catch(ev) { }
    };

    var addEvents = function()
    {
        OE.$doc.querySelectorAll('a[href*="#respond"]');

        if($('a[href*="#respond"].mfp-added').length) {
            $('a[href*="#respond"].mfp-added').first().magnificPopup('open');
        }
    };

    var getRespondContainer = function()
    {
        return OE.$doc.querySelector(querySelector);
    };

    return Plugin;
})());
